<script>
  import { format } from 'svelte-i18n';
  import { Card, CardBody } from '@sveltestrap/sveltestrap';

  import { FolderTreeField, KeyValueField, ListField } from '@client/components/fields/standalone';

  import { destructureTree, structureTree } from '@client/utils/folder-tree';

  export let settings = {};
  export let onUpdate = null;

  const onTreeUpdate = (id, label, values) => onUpdate(id, label, destructureTree(values[0]));

  $: folders = settings.folders.length
    ? settings.folders
    : [
        {
          id: 1,
          parent: '#',
          text: settings.domainname
        }
      ];

  $: files = [structureTree(folders)];
</script>

<div id="marketing">
  <h1 class="mb-3">{$format('label.GENERAL')}</h1>
  <Card>
    <CardBody class="p-4 pt-1">
      <KeyValueField
        id="bannerparams"
        label={$format('label.CUSTOM_URL_PARAMETERS')}
        tooltip={$format('label.TOOLTIP.CUSTOM_URL_PARAMETERS')}
        keyColumnLabel={$format('label.PARAM')}
        valueColumnLabel={$format('label.VALUE')}
        bind:values={settings.bannerparams}
        {onUpdate}
      />

      <ListField
        id="adtags"
        label={$format('label.AD_TAGS')}
        tooltip={$format('label.TOOLTIP.AD_TAGS')}
        bind:values={settings.adtags}
        {onUpdate}
      />

      <FolderTreeField
        id="folders"
        label={$format('label.ASSET_FOLDERS')}
        tooltip={$format('label.TOOLTIP.ASSET_FOLDERS')}
        bind:files
        onUpdate={onTreeUpdate}
      />
    </CardBody>
  </Card>
</div>

<style lang="scss" src="./marketing.scss"></style>
